module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.woff?v=4.7.0
// module chunks = 7